document.addEventListener("mouseover", (e) => {
  let item = e.target;

  if (item.closest("summary.header__menu-item")) {
    let i = item.closest("summary.header__menu-item");
    let parent = i.closest("details");

    let ancestor = i.closest(".header__inline-menu");
    ancestor
      .querySelectorAll("details")
      .forEach((a) => a.removeAttribute("open"));

    parent.setAttribute("open", "");
  }
});

document.querySelectorAll("div.mega-menu__content").forEach((menu) => {
  menu.addEventListener("mouseleave", (e) => {
    const parent = menu.closest("details");
    if (parent) {
      parent.removeAttribute("open");
    }
  });
});
